// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__AlN7j","emails":"CreateEditClinics_emails__AAemj","emailTagLabel":"CreateEditClinics_emailTagLabel__36ozr"};